// src/i18n/translations.js
// 5 languages: Spanish (es), English (en), Portuguese (pt), French (fr), German (de)

const t = {
  es: {
    // Navbar
    nav: {
      home: "Inicio",
      movies: "Películas",
      books: "Libros",
      comics: "Cómics",
      creators: "IA Creators",
      upload: "Subir Contenido",
      pitches: "Panel Pitches",
      users: "Gestión Usuarios",
      videos: "Gestión Vídeos",
      login: "Iniciar sesión",
      register: "Registrarse",
      profile: "Mi Perfil",
      tagline: "Contenido IA · Series · Películas · Libros · Cómics",
    },
    // Hero
    hero: {
      watchNow: "▶ Ver Ahora",
      myList: "+ Mi Lista",
      series: "Serie",
      movie: "Película",
      original: "IA Original",
    },
    // Filas Home
    rows: {
      popularSeries: "🔥 Series Populares",
      featuredMovies: "🎬 Películas Destacadas",
      books: "📚 Biblioteca IA",
      comics: "🎨 Cómics IA",
      newContent: "🆕 Recién Añadido",
      continueWatching: "▶ Continuar viendo",
      seeAll: "Ver todo →",
      watch: "▶ Ver",
    },
    // Auth
    auth: {
      loginTitle: "Iniciar sesión",
      registerTitle: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      loginBtn: "Iniciar sesión",
      registerBtn: "Registrarse",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      registerHere: "Regístrate aquí",
      loginHere: "Inicia sesión aquí",
      loggingIn: "Entrando...",
      registering: "Registrando...",
    },
    // Perfil
    profile: {
      title: "Mi Perfil",
      username: "Nombre de usuario",
      usernamePlaceholder: "Tu nombre visible",
      saveUsername: "Guardar nombre",
      savedOk: "¡Guardado!",
      avatar: "Elige tu avatar",
      changePassword: "Cambiar contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirmar nueva contraseña",
      updatePassword: "Actualizar contraseña",
      passwordOk: "Contraseña actualizada",
      passwordError: "Las contraseñas no coinciden",
      currentPasswordError: "Contraseña actual incorrecta",
      quickActions: "Acciones Rápidas",
      sendPitch: "Enviar Pitch",
      uploadContent: "Subir Contenido",
      favorites: "❤️ Mis Favoritos",
      noFavorites: "No tienes favoritos aún.",
      explore: "Explorar contenido →",
      proposals: "📨 Mis Propuestas",
      noPitches: "No has enviado ningún pitch aún.",
      sendNow: "Enviar ahora →",
      statusPending: "⏳ Pendiente",
      statusApproved: "✅ Aprobado",
      statusRejected: "❌ Rechazado",
      logout: "Cerrar sesión",
      roles: { admin: "Administrador", creator: "Creador", user: "Usuario" },
      faq: "Preguntas Frecuentes",
      contact: "Contacto",
      contactEmail: "Escríbenos a",
      faqItems: [
        { q: "¿Qué es AIVEO?", a: "AIVEO es una plataforma de contenido creado íntegramente con inteligencia artificial: series, películas, libros y cómics generados por IA." },
        { q: "¿Cómo puedo subir mi contenido?", a: "Regístrate como Creador, envía un pitch desde la sección IA Creators y, si es aprobado, podrás subir tu contenido completo." },
        { q: "¿El contenido es gratuito?", a: "Sí, durante el período beta toda la plataforma es de acceso libre." },
        { q: "¿Cómo cambio el idioma?", a: "Usa el selector de idioma en la barra de navegación superior, junto al logo." },
        { q: "¿Puedo descargar el contenido?", a: "Actualmente solo está disponible el streaming online. La descarga estará disponible próximamente." },
      ],
    },
    // Admin
    admin: {
      pitchesTitle: "Panel de Pitches",
      pitchesSubtitle: "Propuestas enviadas por IA Creators",
      all: "Todos",
      pending: "⏳ Pendientes",
      approved: "✅ Aprobados",
      rejected: "❌ Rechazados",
      approve: "✅ Aprobar",
      reject: "❌ Rechazar",
      rejectPrompt: "Motivo de rechazo o feedback:",
      noProposals: "No hay propuestas en esta categoría.",
      restore: "↺ Restaurar demo",
      restoreConfirm: "¿Restaurar los pitches de ejemplo?",
    },
    // Creadores
    creators: {
      title: "IA Creators",
      subtitle: "¿Tienes una idea para una serie, película, libro o cómic creado con IA? Envía tu propuesta.",
      pitchTitle: "Título del proyecto",
      synopsis: "Sinopsis",
      genres: "Géneros",
      submit: "Enviar Pitch",
      success: "¡Propuesta enviada! Te contactaremos pronto.",
      loginRequired: "Debes iniciar sesión para enviar un pitch.",
    },
    // Catálogos
    catalog: {
      books: "📚 Biblioteca IA",
      comics: "🎨 Cómics IA",
      all: "Todos",
      pages: "págs.",
      issues: "números",
      readNow: "Leer Ahora",
      featuredBook: "📚 Libro Destacado",
      featuredComic: "🎨 Cómic Destacado",
    },
    // Común
    common: {
      loading: "Cargando...",
      error: "Ha ocurrido un error.",
      back: "← Volver",
    },
  },

  en: {
    nav: {
      home: "Home",
      movies: "Movies",
      books: "Books",
      comics: "Comics",
      creators: "AI Creators",
      upload: "Upload Content",
      pitches: "Pitches Panel",
      users: "Manage Users",
      videos: "Manage Videos",
      login: "Sign in",
      register: "Sign up",
      profile: "My Profile",
      tagline: "AI Content · Series · Movies · Books · Comics",
    },
    hero: {
      watchNow: "▶ Watch Now",
      myList: "+ My List",
      series: "Series",
      movie: "Movie",
      original: "AI Original",
    },
    rows: {
      popularSeries: "🔥 Popular Series",
      featuredMovies: "🎬 Featured Movies",
      books: "📚 AI Library",
      comics: "🎨 AI Comics",
      newContent: "🆕 Recently Added",
      continueWatching: "▶ Continue Watching",
      seeAll: "See all →",
      watch: "▶ Watch",
    },
    auth: {
      loginTitle: "Sign in",
      registerTitle: "Sign up",
      email: "Email address",
      password: "Password",
      confirmPassword: "Confirm password",
      loginBtn: "Sign in",
      registerBtn: "Sign up",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      registerHere: "Sign up here",
      loginHere: "Sign in here",
      loggingIn: "Signing in...",
      registering: "Registering...",
    },
    profile: {
      title: "My Profile",
      username: "Username",
      usernamePlaceholder: "Your display name",
      saveUsername: "Save name",
      savedOk: "Saved!",
      avatar: "Choose your avatar",
      changePassword: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      updatePassword: "Update password",
      passwordOk: "Password updated",
      passwordError: "Passwords don't match",
      currentPasswordError: "Incorrect current password",
      quickActions: "Quick Actions",
      sendPitch: "Send Pitch",
      uploadContent: "Upload Content",
      favorites: "❤️ My Favorites",
      noFavorites: "No favorites yet.",
      explore: "Explore content →",
      proposals: "📨 My Proposals",
      noPitches: "You haven't submitted any pitches yet.",
      sendNow: "Submit now →",
      statusPending: "⏳ Pending",
      statusApproved: "✅ Approved",
      statusRejected: "❌ Rejected",
      logout: "Sign out",
      roles: { admin: "Administrator", creator: "Creator", user: "User" },
      faq: "Frequently Asked Questions",
      contact: "Contact",
      contactEmail: "Email us at",
      faqItems: [
        { q: "What is AIVEO?", a: "AIVEO is a content platform created entirely with artificial intelligence: AI-generated series, movies, books and comics." },
        { q: "How can I upload my content?", a: "Register as a Creator, submit a pitch from the AI Creators section and, once approved, you can upload your full content." },
        { q: "Is the content free?", a: "Yes, during the beta period the entire platform is free to access." },
        { q: "How do I change the language?", a: "Use the language selector in the top navigation bar, next to the logo." },
        { q: "Can I download content?", a: "Currently only online streaming is available. Downloads will be available soon." },
      ],
    },
    admin: {
      pitchesTitle: "Pitches Panel",
      pitchesSubtitle: "Proposals submitted by AI Creators",
      all: "All",
      pending: "⏳ Pending",
      approved: "✅ Approved",
      rejected: "❌ Rejected",
      approve: "✅ Approve",
      reject: "❌ Reject",
      rejectPrompt: "Reason for rejection or feedback:",
      noProposals: "No proposals in this category.",
      restore: "↺ Restore demo",
      restoreConfirm: "Restore demo pitches?",
    },
    creators: {
      title: "AI Creators",
      subtitle: "Have an idea for an AI-generated series, movie, book or comic? Submit your proposal.",
      pitchTitle: "Project title",
      synopsis: "Synopsis",
      genres: "Genres",
      submit: "Submit Pitch",
      success: "Proposal submitted! We'll contact you soon.",
      loginRequired: "You must be logged in to submit a pitch.",
    },
    catalog: {
      books: "📚 AI Library",
      comics: "🎨 AI Comics",
      all: "All",
      pages: "pages",
      issues: "issues",
      readNow: "Read Now",
      featuredBook: "📚 Featured Book",
      featuredComic: "🎨 Featured Comic",
    },
    common: {
      loading: "Loading...",
      error: "An error occurred.",
      back: "← Back",
    },
  },

  pt: {
    nav: {
      home: "Início",
      movies: "Filmes",
      books: "Livros",
      comics: "Quadrinhos",
      creators: "Criadores IA",
      upload: "Enviar Conteúdo",
      pitches: "Painel de Pitches",
      users: "Gerir Utilizadores",
      videos: "Gerir Vídeos",
      login: "Entrar",
      register: "Registar",
      profile: "Meu Perfil",
      tagline: "Conteúdo IA · Séries · Filmes · Livros · Quadrinhos",
    },
    hero: {
      watchNow: "▶ Assistir Agora",
      myList: "+ Minha Lista",
      series: "Série",
      movie: "Filme",
      original: "Original IA",
    },
    rows: {
      popularSeries: "🔥 Séries Populares",
      featuredMovies: "🎬 Filmes em Destaque",
      books: "📚 Biblioteca IA",
      comics: "🎨 Quadrinhos IA",
      newContent: "🆕 Adicionado Recentemente",
      continueWatching: "▶ Continuar assistindo",
      seeAll: "Ver tudo →",
      watch: "▶ Assistir",
    },
    auth: {
      loginTitle: "Entrar",
      registerTitle: "Registar",
      email: "Endereço de e-mail",
      password: "Senha",
      confirmPassword: "Confirmar senha",
      loginBtn: "Entrar",
      registerBtn: "Registar",
      noAccount: "Não tem conta?",
      hasAccount: "Já tem conta?",
      registerHere: "Registe-se aqui",
      loginHere: "Entre aqui",
      loggingIn: "Entrando...",
      registering: "Registando...",
    },
    profile: {
      title: "Meu Perfil",
      username: "Nome de utilizador",
      usernamePlaceholder: "Seu nome visível",
      saveUsername: "Guardar nome",
      savedOk: "Guardado!",
      avatar: "Escolha o seu avatar",
      changePassword: "Alterar senha",
      currentPassword: "Senha atual",
      newPassword: "Nova senha",
      confirmNewPassword: "Confirmar nova senha",
      updatePassword: "Atualizar senha",
      passwordOk: "Senha atualizada",
      passwordError: "As senhas não coincidem",
      currentPasswordError: "Senha atual incorreta",
      quickActions: "Ações Rápidas",
      sendPitch: "Enviar Pitch",
      uploadContent: "Enviar Conteúdo",
      favorites: "❤️ Meus Favoritos",
      noFavorites: "Ainda não tem favoritos.",
      explore: "Explorar conteúdo →",
      proposals: "📨 Minhas Propostas",
      noPitches: "Ainda não enviou nenhum pitch.",
      sendNow: "Enviar agora →",
      statusPending: "⏳ Pendente",
      statusApproved: "✅ Aprovado",
      statusRejected: "❌ Rejeitado",
      logout: "Sair",
      roles: { admin: "Administrador", creator: "Criador", user: "Utilizador" },
      faq: "Perguntas Frequentes",
      contact: "Contacto",
      contactEmail: "Escreva-nos para",
      faqItems: [
        { q: "O que é o AIVEO?", a: "AIVEO é uma plataforma de conteúdo criado inteiramente com inteligência artificial: séries, filmes, livros e quadrinhos gerados por IA." },
        { q: "Como posso enviar o meu conteúdo?", a: "Registe-se como Criador, envie um pitch pela secção Criadores IA e, se aprovado, poderá enviar o seu conteúdo completo." },
        { q: "O conteúdo é gratuito?", a: "Sim, durante o período beta toda a plataforma é de acesso livre." },
        { q: "Como mudo o idioma?", a: "Use o seletor de idioma na barra de navegação superior, junto ao logotipo." },
        { q: "Posso descarregar o conteúdo?", a: "Atualmente apenas o streaming online está disponível. Os downloads estarão disponíveis em breve." },
      ],
    },
    admin: {
      pitchesTitle: "Painel de Pitches",
      pitchesSubtitle: "Propostas enviadas por Criadores IA",
      all: "Todos",
      pending: "⏳ Pendentes",
      approved: "✅ Aprovados",
      rejected: "❌ Rejeitados",
      approve: "✅ Aprovar",
      reject: "❌ Rejeitar",
      rejectPrompt: "Motivo de rejeição ou feedback:",
      noProposals: "Não há propostas nesta categoria.",
      restore: "↺ Restaurar demo",
      restoreConfirm: "Restaurar pitches de demonstração?",
    },
    creators: {
      title: "Criadores IA",
      subtitle: "Tem uma ideia para uma série, filme, livro ou quadrinho criado com IA? Envie a sua proposta.",
      pitchTitle: "Título do projeto",
      synopsis: "Sinopse",
      genres: "Géneros",
      submit: "Enviar Pitch",
      success: "Proposta enviada! Entraremos em contacto em breve.",
      loginRequired: "Deve iniciar sessão para enviar um pitch.",
    },
    catalog: {
      books: "📚 Biblioteca IA",
      comics: "🎨 Quadrinhos IA",
      all: "Todos",
      pages: "págs.",
      issues: "números",
      readNow: "Ler Agora",
      featuredBook: "📚 Livro em Destaque",
      featuredComic: "🎨 Quadrinho em Destaque",
    },
    common: {
      loading: "Carregando...",
      error: "Ocorreu um erro.",
      back: "← Voltar",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      movies: "Films",
      books: "Livres",
      comics: "BD",
      creators: "Créateurs IA",
      upload: "Téléverser",
      pitches: "Tableau des Pitchs",
      users: "Gérer Utilisateurs",
      videos: "Gérer Vidéos",
      login: "Connexion",
      register: "S'inscrire",
      profile: "Mon Profil",
      tagline: "Contenu IA · Séries · Films · Livres · BD",
    },
    hero: {
      watchNow: "▶ Regarder",
      myList: "+ Ma Liste",
      series: "Série",
      movie: "Film",
      original: "Original IA",
    },
    rows: {
      popularSeries: "🔥 Séries Populaires",
      featuredMovies: "🎬 Films à la Une",
      books: "📚 Bibliothèque IA",
      comics: "🎨 BD IA",
      newContent: "🆕 Récemment Ajouté",
      continueWatching: "▶ Continuer à regarder",
      seeAll: "Voir tout →",
      watch: "▶ Regarder",
    },
    auth: {
      loginTitle: "Connexion",
      registerTitle: "Inscription",
      email: "Adresse e-mail",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      loginBtn: "Se connecter",
      registerBtn: "S'inscrire",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      registerHere: "Inscrivez-vous ici",
      loginHere: "Connectez-vous ici",
      loggingIn: "Connexion...",
      registering: "Inscription...",
    },
    profile: {
      title: "Mon Profil",
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Votre nom visible",
      saveUsername: "Enregistrer le nom",
      savedOk: "Enregistré !",
      avatar: "Choisissez votre avatar",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      updatePassword: "Mettre à jour le mot de passe",
      passwordOk: "Mot de passe mis à jour",
      passwordError: "Les mots de passe ne correspondent pas",
      currentPasswordError: "Mot de passe actuel incorrect",
      quickActions: "Actions Rapides",
      sendPitch: "Envoyer un Pitch",
      uploadContent: "Téléverser du Contenu",
      favorites: "❤️ Mes Favoris",
      noFavorites: "Pas encore de favoris.",
      explore: "Explorer le contenu →",
      proposals: "📨 Mes Propositions",
      noPitches: "Vous n'avez encore soumis aucun pitch.",
      sendNow: "Soumettre maintenant →",
      statusPending: "⏳ En attente",
      statusApproved: "✅ Approuvé",
      statusRejected: "❌ Rejeté",
      logout: "Se déconnecter",
      roles: { admin: "Administrateur", creator: "Créateur", user: "Utilisateur" },
      faq: "Foire Aux Questions",
      contact: "Contact",
      contactEmail: "Écrivez-nous à",
      faqItems: [
        { q: "Qu'est-ce qu'AIVEO ?", a: "AIVEO est une plateforme de contenu créé entièrement par intelligence artificielle : séries, films, livres et BD générés par IA." },
        { q: "Comment téléverser mon contenu ?", a: "Inscrivez-vous en tant que Créateur, soumettez un pitch via la section Créateurs IA et, une fois approuvé, vous pourrez téléverser votre contenu complet." },
        { q: "Le contenu est-il gratuit ?", a: "Oui, pendant la période bêta, toute la plateforme est en accès libre." },
        { q: "Comment changer de langue ?", a: "Utilisez le sélecteur de langue dans la barre de navigation supérieure, à côté du logo." },
        { q: "Puis-je télécharger le contenu ?", a: "Actuellement, seul le streaming en ligne est disponible. Les téléchargements seront disponibles prochainement." },
      ],
    },
    admin: {
      pitchesTitle: "Tableau des Pitchs",
      pitchesSubtitle: "Propositions soumises par les Créateurs IA",
      all: "Tous",
      pending: "⏳ En attente",
      approved: "✅ Approuvés",
      rejected: "❌ Rejetés",
      approve: "✅ Approuver",
      reject: "❌ Rejeter",
      rejectPrompt: "Motif du rejet ou retour d'expérience :",
      noProposals: "Aucune proposition dans cette catégorie.",
      restore: "↺ Restaurer démo",
      restoreConfirm: "Restaurer les pitchs de démonstration ?",
    },
    creators: {
      title: "Créateurs IA",
      subtitle: "Vous avez une idée de série, film, livre ou BD créé par IA ? Soumettez votre proposition.",
      pitchTitle: "Titre du projet",
      synopsis: "Synopsis",
      genres: "Genres",
      submit: "Envoyer le Pitch",
      success: "Proposition envoyée ! Nous vous contacterons bientôt.",
      loginRequired: "Vous devez être connecté pour soumettre un pitch.",
    },
    catalog: {
      books: "📚 Bibliothèque IA",
      comics: "🎨 BD IA",
      all: "Tous",
      pages: "pages",
      issues: "numéros",
      readNow: "Lire Maintenant",
      featuredBook: "📚 Livre à la Une",
      featuredComic: "🎨 BD à la Une",
    },
    common: {
      loading: "Chargement...",
      error: "Une erreur s'est produite.",
      back: "← Retour",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      movies: "Filme",
      books: "Bücher",
      comics: "Comics",
      creators: "KI-Ersteller",
      upload: "Inhalt hochladen",
      pitches: "Pitches-Panel",
      users: "Benutzer verwalten",
      videos: "Videos verwalten",
      login: "Anmelden",
      register: "Registrieren",
      profile: "Mein Profil",
      tagline: "KI-Inhalte · Serien · Filme · Bücher · Comics",
    },
    hero: {
      watchNow: "▶ Jetzt ansehen",
      myList: "+ Meine Liste",
      series: "Serie",
      movie: "Film",
      original: "KI-Original",
    },
    rows: {
      popularSeries: "🔥 Beliebte Serien",
      featuredMovies: "🎬 Empfohlene Filme",
      books: "📚 KI-Bibliothek",
      comics: "🎨 KI-Comics",
      newContent: "🆕 Neu hinzugefügt",
      continueWatching: "▶ Weiterschauen",
      seeAll: "Alle anzeigen →",
      watch: "▶ Ansehen",
    },
    auth: {
      loginTitle: "Anmelden",
      registerTitle: "Registrieren",
      email: "E-Mail-Adresse",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      loginBtn: "Anmelden",
      registerBtn: "Registrieren",
      noAccount: "Noch kein Konto?",
      hasAccount: "Bereits ein Konto?",
      registerHere: "Hier registrieren",
      loginHere: "Hier anmelden",
      loggingIn: "Anmelden...",
      registering: "Registrieren...",
    },
    profile: {
      title: "Mein Profil",
      username: "Benutzername",
      usernamePlaceholder: "Ihr angezeigter Name",
      saveUsername: "Name speichern",
      savedOk: "Gespeichert!",
      avatar: "Avatar wählen",
      changePassword: "Passwort ändern",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort",
      confirmNewPassword: "Neues Passwort bestätigen",
      updatePassword: "Passwort aktualisieren",
      passwordOk: "Passwort aktualisiert",
      passwordError: "Passwörter stimmen nicht überein",
      currentPasswordError: "Aktuelles Passwort falsch",
      quickActions: "Schnellaktionen",
      sendPitch: "Pitch senden",
      uploadContent: "Inhalt hochladen",
      favorites: "❤️ Meine Favoriten",
      noFavorites: "Noch keine Favoriten.",
      explore: "Inhalte entdecken →",
      proposals: "📨 Meine Vorschläge",
      noPitches: "Sie haben noch keinen Pitch eingereicht.",
      sendNow: "Jetzt einreichen →",
      statusPending: "⏳ Ausstehend",
      statusApproved: "✅ Genehmigt",
      statusRejected: "❌ Abgelehnt",
      logout: "Abmelden",
      roles: { admin: "Administrator", creator: "Ersteller", user: "Benutzer" },
      faq: "Häufige Fragen",
      contact: "Kontakt",
      contactEmail: "Schreiben Sie uns an",
      faqItems: [
        { q: "Was ist AIVEO?", a: "AIVEO ist eine Plattform für Inhalte, die vollständig mit künstlicher Intelligenz erstellt wurden: KI-generierte Serien, Filme, Bücher und Comics." },
        { q: "Wie kann ich meine Inhalte hochladen?", a: "Registrieren Sie sich als Ersteller, reichen Sie einen Pitch im Bereich KI-Ersteller ein und nach Genehmigung können Sie Ihre vollständigen Inhalte hochladen." },
        { q: "Sind die Inhalte kostenlos?", a: "Ja, während der Beta-Phase ist die gesamte Plattform kostenlos zugänglich." },
        { q: "Wie ändere ich die Sprache?", a: "Verwenden Sie die Sprachauswahl in der oberen Navigationsleiste neben dem Logo." },
        { q: "Kann ich Inhalte herunterladen?", a: "Derzeit ist nur Online-Streaming verfügbar. Downloads werden in Kürze verfügbar sein." },
      ],
    },
    admin: {
      pitchesTitle: "Pitches-Panel",
      pitchesSubtitle: "Eingereichte Vorschläge von KI-Erstellern",
      all: "Alle",
      pending: "⏳ Ausstehend",
      approved: "✅ Genehmigt",
      rejected: "❌ Abgelehnt",
      approve: "✅ Genehmigen",
      reject: "❌ Ablehnen",
      rejectPrompt: "Ablehnungsgrund oder Feedback:",
      noProposals: "Keine Vorschläge in dieser Kategorie.",
      restore: "↺ Demo wiederherstellen",
      restoreConfirm: "Demo-Pitches wiederherstellen?",
    },
    creators: {
      title: "KI-Ersteller",
      subtitle: "Haben Sie eine Idee für eine KI-generierte Serie, Film, Buch oder Comic? Reichen Sie Ihren Vorschlag ein.",
      pitchTitle: "Projekttitel",
      synopsis: "Zusammenfassung",
      genres: "Genres",
      submit: "Pitch einreichen",
      success: "Vorschlag eingereicht! Wir werden uns bald bei Ihnen melden.",
      loginRequired: "Sie müssen angemeldet sein, um einen Pitch einzureichen.",
    },
    catalog: {
      books: "📚 KI-Bibliothek",
      comics: "🎨 KI-Comics",
      all: "Alle",
      pages: "Seiten",
      issues: "Ausgaben",
      readNow: "Jetzt lesen",
      featuredBook: "📚 Empfohlenes Buch",
      featuredComic: "🎨 Empfohlener Comic",
    },
    common: {
      loading: "Laden...",
      error: "Ein Fehler ist aufgetreten.",
      back: "← Zurück",
    },
  },
};

export default t;
